// extracted by mini-css-extract-plugin
export default {"hideTooltip":"r--z","fadeIn":"s--z","delay":"t--z","recommendedSizeTooltip":"u--z"};